import { appendQueryStringToUrl } from 'shared/helpers/utils/url';
import { Device } from 'shared/types';
import { logger } from 'logging';
import { localStorageService } from 'client/service/storage';
import { pages } from 'shared/constants/urls';
import { logErrors } from 'helpers/utils/logErrors';
import { getAuthFromStorage } from 'shared/store/auth/helper';

const MOB_MAP = 'M_MAP';
const MOB_NO = 'M_NO';
const AUTO_FILL = 'Atf';
const AUTO_FILL_SHOWN = 'af_s';
const USER_REG = 'USER_REG';
const TRUECALLER_SHOWN = 'af_trc';

/**
 * @deprecated
 */
export const redirectAuthPage = (root?: string) => {
  try {
    const CURRENT_URL = 'CURRENT_URL';
    const locationPathName = `${window.location.pathname}${window.location.search}`;
    localStorageService.setItem(CURRENT_URL, locationPathName);
  } catch (err) {
    logger.error(err, 'Error: authCurrentUrlInStorage');
  }
  window.location.href = `${pages.AUTH_PAGE}${root ? `&root=${root}` : ''}`;
};

export const postLoginRedirectionMap = (url: string) => {
  if (url.includes('/coupons-offers')) {
    return '/coupons';
  }
  return url;
};

export const setCurrentUrlForAuth = () => {
  try {
    const CURRENT_URL = 'CURRENT_URL';
    const locationPathName = `${window.location.pathname}${window.location.search}`;
    const currentPath = postLoginRedirectionMap(locationPathName);
    localStorageService.setItem(CURRENT_URL, currentPath);
  } catch (err) {
    logger.error(err, 'Error: setAuthCurrentUrlInStorage');
  }
};

export const handleAuthNavigation = (
  redirectUrl: string,
  device: Device = Device.WEB
) => {
  const redirectQueryString = `redirect=${encodeURIComponent(redirectUrl)}`;
  switch (device) {
    case Device.ANDROID:
      window.AndroidFunction.initiateLogin(redirectUrl);
      break;
    case Device.IOS:
      window.location.href = `nykaaioslanding://initiateLogin?nextUrlToLoadIfLoginSuccess=${encodeURIComponent(
        redirectUrl
      )}`;
      break;
    case Device.WEB:
    default:
      window.location.href = appendQueryStringToUrl(
        pages.AUTH_PAGE,
        redirectQueryString
      );
      break;
  }
};

export const getMobileNumberFromCache = () => {
  try {
    const number = sessionStorage.getItem(MOB_NO);
    if (number) {
      const parsed = JSON.parse(number);
      return typeof parsed === 'number' ? parsed : parseInt(parsed);
    }
  } catch (err) {
    logErrors(err, 'getMobileNumberFromCache');
    return '';
  }
};

export const setAuthSteps = (step: number) => {
  try {
    sessionStorage.setItem(MOB_MAP, step);
  } catch (err) {
    logErrors(err, 'deleteAuthSteps');
  }
};
export const getAuthSteps = () => {
  try {
    const step = sessionStorage.getItem(MOB_MAP);
    if (step) {
      const parsed = JSON.parse(step);
      return parsed;
    }
  } catch (err) {
    logErrors(err, 'getAuthSteps');
  }
};

export const deleteAuthSteps = () => {
  try {
    sessionStorage.removeItem(MOB_MAP);
  } catch (err) {
    logErrors(err, 'deleteAuthSteps');
  }
};

export const deleteMobileNumberFromCache = () => {
  try {
    sessionStorage.removeItem(MOB_NO);
  } catch (err) {
    logErrors(err, 'deleteMobileNumberFromCache');
  }
};

export const getMobileNumberLocal = () => {
  try {
    return localStorageService.getItem(MOB_NO);
  } catch (err) {
    logErrors(err, 'getMobileNumberLocal');
  }
};

export const setMobileNumberLocal = (mobNumber) => {
  try {
    return localStorageService.setItem(MOB_NO, mobNumber);
  } catch (err) {
    logErrors(err, 'setMobileNumberLocal');
  }
};

export const setAutofillFlag = (val: string) => {
  try {
    sessionStorage.setItem(AUTO_FILL, val);
  } catch (err) {
    logErrors(err, 'setAutofillFlag');
  }
};

export const isAutoFill = () => {
  try {
    return sessionStorage.getItem(AUTO_FILL);
  } catch (err) {
    logErrors(err, 'isAutoFill');
  }
};

export const isAutoFillShown = () => {
  try {
    return sessionStorage.getItem(AUTO_FILL_SHOWN);
  } catch (err) {
    logErrors(err, 'isAutoFillShown');
  }
};

export const setAutoFillShown = () => {
  try {
    return sessionStorage.setItem(AUTO_FILL_SHOWN, '1');
  } catch (err) {
    logErrors(err, 'setAutoFillShown');
  }
};

export const isLoyalUser = () => {
  const auth = getAuthFromStorage() || {};
  return auth.data?.result?.customerData?.is_loyal;
};

export const handleVerloopChat = () => {
  if (typeof window !== 'undefined') {
    window?.Verloop?.livechat.openWidget();
  }
};

export const setRegistration = () => {
  try {
    sessionStorage.setItem(USER_REG, 'true');
  } catch (err) {
    logErrors(err, 'setRegistration');
  }
};

export const getRegistration = () => {
  try {
    return sessionStorage.getItem(USER_REG) === 'true';
  } catch (err) {
    logErrors(err, 'getRegistration');
  }
};

export const deleteRegistration = () => {
  try {
    sessionStorage.removeItem(USER_REG);
  } catch (err) {
    logErrors(err, 'deleteRegistration');
  }
};

export const isTrueCallerShown = () => {
  try {
    return sessionStorage.getItem(TRUECALLER_SHOWN);
  } catch (err) {
    logErrors(err, 'isTrueCallerShown');
  }
};
